export default function () {
	// 現在のページURLを取得
	const url = location.href;

	// URLを「/」で分割して配列にする
	const urlArray = url.split('/');

	// URLの最後から2番目の要素を取得
	// 例: https://example.com/blog-cat/design/
	// → ["https:", "", "example.com", "blog-cat", "design", ""]
	// → urlArray[urlArray.length - 2] = "design"
	const urlLast = urlArray[urlArray.length - 2];

	// セレクトボックスの中から、現在のURLに対応するoptionを選択状態にする
	$('#select_link')
		.find('option[value="' + urlLast + '"]')
		.attr('selected', 'selected');

	// セレクトボックスの値が変更されたときの処理
	$('#select_link').on('change', function () {
		// 「all」が選択された場合はブログの一覧ページへ遷移
		if ($(this).val() === 'all') {
			location.href = '/blog/';
			return false; // 処理を終了
		}

		// それ以外の場合は、選択されたカテゴリーページへ遷移
		// 例: value="design" の場合 → /blog-cat/design/
		location.href = `/blog-cat/${$(this).val()}/`;
	});
}